<template>
  <button class="btn" :disabled="loading">
    <slot></slot>
    <span class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true" v-if="loading"></span>
  </button>
</template>

<script>
export default {
  name: "LoadingButton",
  props: ['loading']
}
</script>

<style scoped>

</style>